<template>
  <v-app-bar
    class="sticky-top"
    color="#d9753b"
    dense
    dark
  >
    <v-btn
      icon
      @click="goBack">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-row no-gutters>
      <v-text-field
        v-model="keyword"
        v-debounce="onChange"
        type="text"
        class="mr-4"
        solo
        flat
        :label="$t('searchPage.searchBar.label')"
        light
        dense
        hide-details
        clearable
        prepend-inner-icon="mdi-magnify"
      ></v-text-field>
    </v-row>
  </v-app-bar>
</template>

<script>

export default {
  name: "SearchBar",
  props: {},
  data () {
    return {
      keyword: null
    }
  },
  methods: {
    goBack() {
      window.history.back();
    },
    onChange() {
      this.$emit('change', this.keyword)
    }
  },
  watch: { // this is necessary for updating serach result when clear button is clicked
    keyword: function () {
      if (this.keyword === null || this.keyword === '') {
        this.$emit('change', this.keyword)
      }
    }
  }
}
</script>

<style scoped>

</style>